import { useWorkflowServiceRequestTemplate } from '@commenda/api/workflow-template';
import { ServiceRequestTemplate } from '@commenda/types/src/service-request/types';
import { createContext, ReactNode, useContext, useMemo } from 'react';

interface IWorkflowTaskTemplate {
  /** The task groups the workflow's steps bind against, as its links decide. */
  taskGroups: ServiceRequestTemplate['taskGroups'];
  isLoading: boolean;
}

// Empty everywhere but inside a host that names the workflow: the pickers then offer no keys.
const WorkflowTaskTemplateContext = createContext<IWorkflowTaskTemplate>({
  taskGroups: [],
  isLoading: false,
});

export const useWorkflowTaskTemplate = (): IWorkflowTaskTemplate =>
  useContext(WorkflowTaskTemplateContext);

export const WorkflowTaskTemplateProvider = ({
  workflowTemplateId,
  children,
}: {
  workflowTemplateId: string;
  children: ReactNode;
}) => {
  const { template, isLoading } =
    useWorkflowServiceRequestTemplate(workflowTemplateId);
  const value = useMemo(
    () => ({ taskGroups: template?.taskGroups ?? [], isLoading }),
    [template, isLoading]
  );
  return (
    <WorkflowTaskTemplateContext.Provider value={value}>
      {children}
    </WorkflowTaskTemplateContext.Provider>
  );
};
